import { Suspense } from 'react'
import { Route, Routes, type RouteProps } from 'react-router-dom'
import { appRoutes } from './index'
import Layout from '../components/Layout'

const AppRouter = (props: RouteProps) => {

  return (
    <Layout>
      <Routes>
        {(appRoutes || []).map((route, idx) => (
          <Route
            key={idx + route.name}
            path={route.path}
            element={
              <Suspense {...props}>
                {route.element}
              </Suspense>
            }
          />
        ))}
      </Routes>
    </Layout>
  )
}

export default AppRouter
